export default __webpack_public_path__ + "static/media/audioLetalk.224cb85b.mp3";